var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  本次服务将在\n  "),_c('span',{staticClass:"time",style:({ color: _vm.color, fontSize: _vm.fontSize + 'px', fontWeight: 600 })},[_vm._v(_vm._s(_vm.hour
        ? _vm.hourString + ":" + _vm.minuteString + ":" + _vm.secondString
        : _vm.minuteString + ":" + _vm.secondString))]),_vm._v("后结束\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b03c6aa0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/countDown.vue
// module id = null
// module chunks = 